import {date} from 'redux-form-validators';

export const DATE_FORMAT = 'yyyy-mm-dd';

export default opts =>
  date({
    message: {
      id: 'validation.invalidDate'
    },
    allowBlank: true,
    format: DATE_FORMAT,
    ...opts
  });



// WEBPACK FOOTER //
// ./validators/units/date.js